module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/mediastore-data-2017-09-01.paginators.json
// module id = 449
// module chunks = 1